import { render, staticRenderFns } from "./SCommercialPackage.vue?vue&type=template&id=7a105a42&scoped=true"
import script from "./SCommercialPackage.vue?vue&type=script&lang=js"
export * from "./SCommercialPackage.vue?vue&type=script&lang=js"
import style0 from "./SCommercialPackage.vue?vue&type=style&index=0&id=7a105a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a105a42",
  null
  
)

export default component.exports